// Brown University's concentrations (Brown's word for majors) (#2739). Read
// on 2026-10-01 from the official 2026-27 University Bulletin, The College,
// Undergraduate Concentrations (bulletin.brown.edu), which lists 89
// concentrations A to Z. The degree each leads to (A.B., Sc.B. or both) is
// as brown.edu's Undergraduate Programs list writes it; a concentration that
// offers both is listed once per degree. Two Bulletin concentrations are not
// on that list: Computational Chemistry and Chemical Physics, whose Bulletin
// page gives the "Standard program for the Sc.B. degree", and Philosophy,
// Politics, and Economics, whose Bulletin page names no degree, so it shows
// none. Four names on the Undergraduate Programs list are not concentrations
// in the 2026-27 Bulletin (Business, Entrepreneurship, and Organizations;
// Development Studies; International Relations; Public Policy) and are left
// out, as are certificates and the undergraduate professional tracks.
const majors = {
    "slug": "brown-university",
    "read": "2026-10-01",
    "intro": "Every concentration (major) in Brown's official 2026-27 University Bulletin, with the degree it leads to: the A.B. (bachelor of arts), the Sc.B. (bachelor of science) or either. Certificates are left out.",
    "groups": [
        {
            "name": "Concentrations, A to Z",
            "source": {
                "label": "Brown University Bulletin 2026-27, Undergraduate Concentrations",
                "url": "https://bulletin.brown.edu/the-college/concentrations/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "A.B."
                },
                {
                    "name": "American Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Anthropology",
                    "degree": "A.B."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "A.B."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Applied Mathematics-Biology",
                    "degree": "Sc.B."
                },
                {
                    "name": "Applied Mathematics-Computer Science",
                    "degree": "Sc.B."
                },
                {
                    "name": "Applied Mathematics-Economics",
                    "degree": "A.B."
                },
                {
                    "name": "Applied Mathematics-Economics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Archaeology and the Ancient World",
                    "degree": "A.B."
                },
                {
                    "name": "Architecture",
                    "degree": "A.B."
                },
                {
                    "name": "Astronomy",
                    "degree": "A.B."
                },
                {
                    "name": "Behavioral Decision Sciences",
                    "degree": "A.B."
                },
                {
                    "name": "Biochemistry & Molecular Biology",
                    "degree": "Sc.B."
                },
                {
                    "name": "Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Biology",
                    "degree": "Sc.B."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Biophysics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Chemical Physics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Chemistry",
                    "degree": "A.B."
                },
                {
                    "name": "Chemistry",
                    "degree": "Sc.B."
                },
                {
                    "name": "Classics",
                    "degree": "A.B."
                },
                {
                    "name": "Cognitive Neuroscience",
                    "degree": "A.B."
                },
                {
                    "name": "Cognitive Neuroscience",
                    "degree": "Sc.B."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "A.B."
                },
                {
                    "name": "Cognitive Science",
                    "degree": "Sc.B."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "A.B."
                },
                {
                    "name": "Computational Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Computational Biology",
                    "degree": "Sc.B."
                },
                {
                    "name": "Computational Chemistry and Chemical Physics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Computational Neuroscience",
                    "degree": "Sc.B."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Computer Science",
                    "degree": "A.B."
                },
                {
                    "name": "Computer Science",
                    "degree": "Sc.B."
                },
                {
                    "name": "Computer Science-Economics",
                    "degree": "A.B."
                },
                {
                    "name": "Computer Science-Economics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Contemplative Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Critical Native American and Indigenous Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Design Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Early Modern World",
                    "degree": "A.B."
                },
                {
                    "name": "Earth and Planetary Science",
                    "degree": "A.B."
                },
                {
                    "name": "Earth and Planetary Science",
                    "degree": "Sc.B."
                },
                {
                    "name": "Earth, Climate, and Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Earth, Climate, and Biology",
                    "degree": "Sc.B."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Economics",
                    "degree": "A.B."
                },
                {
                    "name": "Education Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Egyptology and Assyriology",
                    "degree": "A.B."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Engineering",
                    "degree": "A.B."
                },
                {
                    "name": "Engineering and Physics",
                    "degree": "Sc.B."
                },
                {
                    "name": "English",
                    "degree": "A.B."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Environmental Sciences and Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Environmental Sciences and Studies",
                    "degree": "Sc.B."
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "A.B."
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Geochemistry and Environmental Chemistry",
                    "degree": "A.B."
                },
                {
                    "name": "Geochemistry and Environmental Chemistry",
                    "degree": "Sc.B."
                },
                {
                    "name": "Geophysics and Climate Physics",
                    "degree": "A.B."
                },
                {
                    "name": "Geophysics and Climate Physics",
                    "degree": "Sc.B."
                },
                {
                    "name": "German Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Health & Human Biology",
                    "degree": "A.B."
                },
                {
                    "name": "Hispanic Literatures and Cultures",
                    "degree": "A.B."
                },
                {
                    "name": "History",
                    "degree": "A.B."
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "A.B."
                },
                {
                    "name": "Independent Concentration",
                    "degree": "A.B."
                },
                {
                    "name": "Independent Concentration",
                    "degree": "Sc.B."
                },
                {
                    "name": "International and Public Affairs",
                    "degree": "A.B."
                },
                {
                    "name": "Italian Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Linguistics",
                    "degree": "A.B."
                },
                {
                    "name": "Linguistics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Literary Arts",
                    "degree": "A.B."
                },
                {
                    "name": "Materials Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Mathematics",
                    "degree": "A.B."
                },
                {
                    "name": "Mathematics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Mathematics-Computer Science",
                    "degree": "Sc.B."
                },
                {
                    "name": "Mathematics-Economics",
                    "degree": "A.B."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Sc.B."
                },
                {
                    "name": "Medieval Cultures",
                    "degree": "A.B."
                },
                {
                    "name": "Middle East Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Modern Culture and Media",
                    "degree": "A.B."
                },
                {
                    "name": "Music",
                    "degree": "A.B."
                },
                {
                    "name": "Neuroscience",
                    "degree": "Sc.B."
                },
                {
                    "name": "Philosophy",
                    "degree": "A.B."
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": "A.B."
                },
                {
                    "name": "Physics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Physics and Philosophy",
                    "degree": "A.B."
                },
                {
                    "name": "Political Science",
                    "degree": "A.B."
                },
                {
                    "name": "Portuguese and Brazilian Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Psychology",
                    "degree": "A.B."
                },
                {
                    "name": "Psychology",
                    "degree": "Sc.B."
                },
                {
                    "name": "Public Health",
                    "degree": "A.B."
                },
                {
                    "name": "Religious Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Science, Technology, and Society",
                    "degree": "A.B."
                },
                {
                    "name": "Slavic Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Social Analysis and Research",
                    "degree": "Sc.B."
                },
                {
                    "name": "Sociology",
                    "degree": "A.B."
                },
                {
                    "name": "South Asian Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Statistics",
                    "degree": "Sc.B."
                },
                {
                    "name": "Theatre Arts and Performance Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Urban Studies",
                    "degree": "A.B."
                },
                {
                    "name": "Visual Art",
                    "degree": "A.B."
                }
            ]
        }
    ]
};

export default majors;
